<div class="modal-header" style="background-color:#fff;">
    <div class="container-fluid">
        <div class="row" style="height: 250px; border: 1px solid black;">
            <!-- Imagen lateral -->
            <div class="col h-100">
                <img src="{{eventImage}}" class="img-fluid h-100">
            </div>
        </div>
        <div class="row" style="height: 250px; border: 1px solid black;">
            <!-- Contenedor de esquema -->
            <div class="col h-100" style="overflow-x: auto; overflow-y: hidden;">
                <canvas id="myCanvas" #myCanvas style="width: 1800px; height: 100%;"></canvas>
            </div>
        </div>
    </div>
</div>

<div class="modal-body" style="background-color:#fff; box-shadow: 0px 7px 5px silver;">
    <div class="container-fluid">
        <form #typForm="ngForm">
            <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="vehSelector">{{ 'typification.vehicles' | translate }}</label>
                    <!--
                    <select (change)="vehicleSelected($event.target.value)" class="custom-select" id="vehSelector"
                        [disabled]="isBlocked">-->
                    <select [(ngModel)]="selectedVehicle" (ngModelChange)="vehicleSelected($event)"
                        class="custom-select" id="vehSelector" [disabled]="isBlocked" name="vehicleSelector">


                        <ng-container *ngFor="let vehicles of vehicleBunde">
                            <ng-container *ngIf="vehicles.order === '2' && vehicles.type !== 'cabin'">
                                <option selected [value]="vehicles.order - 1">{{vehicles.order - 1}}</option>


                            </ng-container>
                            <ng-container
                                *ngIf="vehicles.order !== '2' && vehicles.order !== '1' && vehicles.type !== 'cabin'">
                                <!-- <option>{{vehicles.order - 1}}</option> -->

                                <option [value]="vehicles.order - 1">
                                    {{vehicles.order - 1}}
                                </option>

                            </ng-container>
                        </ng-container>
                    </select>
                </div>
                <div class="form-group col-md-3">

                    <!-- 🔽 Globo flotante -->
                    <small *ngIf="forcePlate" class="speech-bubble">
                        Ingresa y confirma la patente
                    </small>

                    <!-- Label normal -->
                    <label for="plate">
                        {{ 'typification.plate' | translate }}
                    </label>
                    <!-- 🟠 MODO FORZADO -->
                    <ng-container *ngIf="forcePlate; else normalPlate">
                        <div class="input-group">
                            <input #plateInput type="text" class="form-control force-plate" id="plate"
                                [ngModel]="vehicleBunde[vehicleIndex].id" (ngModelChange)="onPlateChange($event)"
                                name="plate" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-warning btn-sm confirm-btn"
                                    (click)="confirmPlate()" title="Confirmar patente">
                                    ✔
                                </button>
                            </div>
                        </div>
                    </ng-container>
                    <!-- 🔵 MODO NORMAL -->
                    <ng-template #normalPlate>
                        <ng-container *ngIf="systemTypConfig.editPlate === 'true'; else disabledPlate">
                            <input type="text" class="form-control" id="plate" [ngModel]="vehicleBunde[vehicleIndex].id"
                                (ngModelChange)="onPlateChange($event)" name="plate" />
                        </ng-container>
                        <ng-template #disabledPlate>
                            <input type="text" class="form-control" id="plate" [ngModel]="vehicleBunde[vehicleIndex].id"
                                name="plate" disabled />
                        </ng-template>
                    </ng-template>
                </div>


                <div class="form-group col-md-3">
                    <label for="bundleSelector">{{ 'typification.container' | translate }}</label>
                    <select (change)="bundleSelected($event.target.value);" class="custom-select" id="bundleSelector"
                        [disabled]="isBlocked">
                        <ng-container *ngFor="let bundle of vehicleBunde[vehicleIndex].elements.element">
                            <ng-container *ngIf="bundle.id === '1'">
                                <option selected>{{bundle.id}}</option>
                            </ng-container>
                            <ng-container *ngIf="bundle.id !== '1'">
                                <option>{{bundle.id}}</option>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>

                <div class="form-group col-md-3">
                    <label for="bundleArrangementSelector">{{ 'typification.container-load' | translate }}</label>
                    <select class="custom-select" id="bundleArrangementSelector"
                        (change)="bundleArrangementSelected($event)" [disabled]="isBlocked">
                        <ng-container *ngFor="let arrangement of systemTypConfig.loads">
                            <ng-container
                                *ngFor="let param of vehicleBunde[vehicleIndex].elements.element[bundleIndex].params.param">
                                <ng-container *ngIf="param.name === 'arrange'">
                                    <option [value]="arrangement.value" [selected]="param.value === arrangement.value">
                                        {{arrangement.value}}
                                    </option>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-3">
                    <label>{{ 'typification.total-vehicles' | translate }} {{vehicleBunde.length - 1}}</label>
                </div>
                <div class="form-group col-md-3">
                    <label>{{ 'typification.total-container' | translate }}
                        {{vehicleBunde[vehicleIndex].elements.element.length}}</label>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-3">
                    <ng-container
                        *ngIf="!systemTypConfig.maxContainerVehicle || (vehicleBunde.length - 1) < systemTypConfig.maxContainerVehicle">
                        <button id="btn_add_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newVehicle();" [disabled]="isBlocked || systemTypConfig.canAddContainers == 'false'">
                            {{ 'typification.add-vehicle' | translate }}
                        </button>
                    </ng-container>
                    <ng-container *ngIf="(vehicleBunde.length - 1) == systemTypConfig.maxContainerVehicle">
                        <button id="btn_add_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newVehicle();" disabled>{{ 'typification.add-vehicle' | translate }}</button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].order === '2'">
                        <button id="btn_remove_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            ngbTooltip="{{ 'typification.first-vehicle-remove' | translate }}" disabled>{{
                            'typification.remove-vehicle' | translate }}
                        </button>
                    </ng-container>
                    <ng-container
                        *ngIf="vehicleBunde[vehicleIndex].order !== '2' && vehicleBunde[vehicleIndex].order !== '1'">
                        <button id="btn_remove_vehicle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="deleteVehicle();" [disabled]="isBlocked">
                            {{ 'typification.remove-vehicle' | translate }}
                        </button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container
                        *ngIf="!systemTypConfig.maxContainer || vehicleBunde[vehicleIndex].elements.element.length < systemTypConfig.maxContainer">
                        <button id="btn_add_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newBundle();">{{ 'typification.add-container' | translate }}</button>
                    </ng-container>
                    <ng-container
                        *ngIf="vehicleBunde[vehicleIndex].elements.element.length == systemTypConfig.maxContainer">
                        <button id="btn_add_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="newBundle();" disabled>{{ 'typification.add-container' | translate }}</button>
                    </ng-container>
                </div>
                <div class="form-group col-md-3">
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].elements.element[bundleIndex].id === '1'">
                        <button id="btn_remove_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            ngbTooltip="{{ 'typification.first-container-remove' | translate }}" disabled>{{
                            'typification.remove-container' | translate }}</button>
                    </ng-container>
                    <ng-container *ngIf="vehicleBunde[vehicleIndex].elements.element[bundleIndex].id !== '1'">
                        <button id="btn_remove_bundle" type="button" class="btn sharp btn-outline-secondary btn-block"
                            (click)="deleteBundle();">{{ 'typification.remove-container' | translate }}</button>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="modal-footer" style="background-color:#fff; box-shadow: 0px 7px 5px silver;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-4 text-left">
                <button id="btn_exit" type="button" class="btn sharp btn-outline-secondary btn-lg"
                    (click)="activeModal.dismiss('exits click')">{{ 'typification.exit' | translate }}</button>
            </div>
            <div class="col-8 text-right">
                <button id="btn_undo" type="button" class="btn sharp btn-outline-secondary btn-lg"
                    (click)="resetTyp();">{{ 'typificzation.undo' | translate }}</button>
                &nbsp;
                <button type="btn_save" class="btn sharp btn-outline-secondary btn-lg" (click)="saveTyp();"
                    [disabled]="isBlocked">
                    {{'typification.next' | translate }}</button>
            </div>
        </div>
    </div>
</div>
